import { showToast } from "vant"
import { computed } from "vue"
import { useRoute } from "vue-router"
import { useStore } from "vuex"
import { removeParam } from '@/utils'

const useWechat = () => {
  const route = useRoute()
  const store = useStore()
  const commonDsl = computed(() => store.state.dslData.commonDsl)
  const publicOfficialInfo = computed(() => store.state.publicOfficialInfo)
  const userInfo = computed(() => store.state.userInfo)

  const getPublicOfficialInfo = async () => {
    const { code, data, msg } = await store.dispatch('getPublicOfficialInfo', {
      key: route.query.key || commonDsl.value?.publicKey || 'wechat-common-htz'
    })
    if (code === 1) store.commit('setPublicOfficialInfo', data)
    else showToast(msg || '获取公众号信息失败')
  }

  // 通过localstorage中的token来获取用户信息
  const userInfoByToken = async (token) => {
    const { originId, serverId = 200 } = publicOfficialInfo.value
    const { code, data } = await store.dispatch('getUserByToken', { token, serverId })
    if (code === 1) store.commit('setUserInfo', data)
    else localStorage.removeItem(`${originId}:token`)
  }

  // 通过code获取用户信息
  const userInfoByCode = async (code) => {
    const { originId = '', serverId = 200 } = publicOfficialInfo.value
    const { code: resCode, result } = await store.dispatch('getUserByCode', { originId, serverId, code })
    if (resCode === 0) {
      store.commit('setUserInfo', result)
      if (result?.userInfo?.token) localStorage.setItem(`${originId}:token`, result?.userInfo?.token)
    }
  }

  // 重定向事件
  const redirect = () => {
    const { appId, scope = 'snsapi_userinfo', state = 'STATE' } = publicOfficialInfo.value
    const url = window.location.href
    var noStateUrl = removeParam('state', url)
    var newUrl = removeParam('code', noStateUrl)
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(newUrl)}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
  }

  const wechatAuth = async () => {
    document.body.style.pointerEvents = 'none'
    /**
		 * 先去通过key拿公众号的信息
		 * 如果有token的话 那么尝试用token拿用户信息 取不到的话那么就不做处理
		 * 如果有code的话 那么尝试用code拿用户信息 取不到的话那么就不做处理
		 * 如果上面两项结束后没有取到用户信息的话，那么就给所有元素加上click为redirect的事件，点击拉起授权
		 * 否则就表示授权成功，可以取到用户信息
		 */
    await getPublicOfficialInfo()
    const { originId = '' } = publicOfficialInfo.value
    if (!originId) return ''
    const token = localStorage.getItem(`${originId}:token`)
    const { code, preview } = route.query
    if (token) await userInfoByToken(token)
    else if (code) await userInfoByCode(code)

    // 如果经过以上步骤都没有拿到用户信息 那么就给全局增加重定向点击事件
    // 列表预览时不添加操作事件
    if (preview) return
    if (!userInfo.value.unionid) {
      document.querySelector('html').addEventListener('click', () => {
        redirect()
      })
    } else document.body.style.pointerEvents = 'initial'
  }

  return {
    wechatAuth
  }
}

export default useWechat